export default {
      id: "favorite-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#favorite",
      toString: function () {
        return this.url;
      }
    }